const COVERS_BASE = "/scrapbook/covers";
const BG_BASE = "/scrapbook/backgrounds";
const JP_STICKERS_BASE = "/scrapbook/stickers/japon";
const NY_STICKERS_BASE = "/scrapbook/stickers/ny";
const CN_STICKERS_BASE = "/scrapbook/stickers/china";
const LON_STICKERS_BASE = "/scrapbook/stickers/londres";
const PARIS_STICKERS_BASE = "/scrapbook/stickers/paris";
const DECO_STICKERS_BASE = "/scrapbook/stickers/decorativos";
const WASHI_BASE = "/scrapbook/washi";

/* ═══════════════════════════════════════════════
   Canvas dimensions (Stories format)
   ═══════════════════════════════════════════════ */
export const CANVAS_W = 1080;
export const CANVAS_H = 1920;

/* ═══════════════════════════════════════════════
   Backgrounds — solid colors + illustrated images
   ═══════════════════════════════════════════════ */
export const BACKGROUNDS = [
	{
		id: "scrap-1",
		name: "Sellos",
		color: "#F5F0E8",
		image: `${BG_BASE}/fondo-scrap-1.png`,
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.55)",
		accent: "#c4956a",
	},
	{
		id: "scrap-2",
		name: "Viaje cálido",
		color: "#F3EDE4",
		image: `${BG_BASE}/fondo-scrap-2.png`,
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.55)",
		accent: "#c45c4a",
	},
	{
		id: "scrap-3",
		name: "Rosa viaje",
		color: "#F8E8E8",
		image: `${BG_BASE}/fondo-scrap-3.png`,
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.5)",
		accent: "#5a8a8a",
	},
	{
		id: "scrap-4",
		name: "Azul viaje",
		color: "#D6E8F0",
		image: `${BG_BASE}/fondo-scrap-4.png`,
		text: "#2c3e50",
		textSoft: "rgba(44,62,80,0.5)",
		accent: "#c45c4a",
	},
	{
		id: "scrap-5",
		name: "Vacaciones",
		color: "#F7F1E8",
		image: `${BG_BASE}/fondo-scrap-5.png`,
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.5)",
		accent: "#e8677d",
	},
	{
		id: "scrap-6",
		name: "Aventura",
		color: "#B8D4E8",
		image: `${BG_BASE}/fondo-scrap-6.png`,
		text: "#2c3e50",
		textSoft: "rgba(44,62,80,0.5)",
		accent: "#e85d4c",
	},
	{
		id: "scrap-7",
		name: "Vintage",
		color: "#C97B6B",
		image: `${BG_BASE}/fondo-scrap-7.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#4a7c7c",
	},
	{
		id: "scrap-8",
		name: "Vuelo",
		color: "#F5F2EC",
		image: `${BG_BASE}/fondo-scrap-8.png`,
		text: "#1a2744",
		textSoft: "rgba(26,39,68,0.5)",
		accent: "#e8a090",
	},
	{
		id: "scrap-9",
		name: "Nueva York",
		color: "#F2D9C9",
		image: `${BG_BASE}/fondo-scrap-9.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#1e3a5f",
	},
	{
		id: "scrap-10",
		name: "Japón",
		color: "#F5D6D6",
		image: `${BG_BASE}/fondo-scrap-10.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c41e3a",
	},
	{
		id: "scrap-11",
		name: "París",
		color: "#F0E6D8",
		image: `${BG_BASE}/fondo-scrap-11.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#5a7a9a",
	},
	{
		id: "scrap-12",
		name: "Londres",
		color: "#E8E6E4",
		image: `${BG_BASE}/fondo-scrap-12.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c41e3a",
	},
	{
		id: "scrap-13",
		name: "Equipaje",
		color: "#F5E8DC",
		image: `${BG_BASE}/fondo-scrap-13.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c45c4a",
	},
	{
		id: "scrap-14",
		name: "Boho",
		color: "#F5F0E8",
		image: `${BG_BASE}/fondo-scrap-14.png`,
		text: "#1a2744",
		textSoft: "rgba(26,39,68,0.5)",
		accent: "#c47a5a",
	},
	{
		id: "scrap-16",
		name: "Postal",
		color: "#D4C4A8",
		image: `${BG_BASE}/fondo-scrap-16.png`,
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.55)",
		accent: "#8b6f47",
	},
	{
		id: "scrap-17",
		name: "Papel",
		color: "#E8DCC8",
		image: `${BG_BASE}/fondo-scrap-17.png`,
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.55)",
		accent: "#c4956a",
	},
	{
		id: "scrap-18",
		name: "Ruta USA",
		color: "#F5E6D8",
		image: `${BG_BASE}/fondo-scrap-18.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c45c26",
	},
	{
		id: "scrap-19",
		name: "China",
		color: "#F5E8DC",
		image: `${BG_BASE}/fondo-scrap-19.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c41e3a",
	},
	{
		id: "scrap-20",
		name: "Seúl",
		color: "#F0E6D8",
		image: `${BG_BASE}/fondo-scrap-20.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c45c7a",
	},
	{
		id: "scrap-21",
		name: "NY Collage",
		color: "#F0E6D8",
		image: `${BG_BASE}/fondo-scrap-21.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#1e3a5f",
	},
	{
		id: "scrap-22",
		name: "Maleta",
		color: "#F5EDE0",
		image: `${BG_BASE}/fondo-scrap-22.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#3d6b8a",
	},
	{
		id: "scrap-23",
		name: "Brújula",
		color: "#F5EDE0",
		image: `${BG_BASE}/fondo-scrap-23.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#3d6b8a",
	},
	{
		id: "scrap-24",
		name: "Avioncito",
		color: "#F5EDE0",
		image: `${BG_BASE}/fondo-scrap-24.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c45c4a",
	},
	{
		id: "scrap-25",
		name: "Café",
		color: "#F5EDE0",
		image: `${BG_BASE}/fondo-scrap-25.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c45c4a",
	},
	{
		id: "scrap-26",
		name: "Brújula viaje",
		color: "#F5EDE0",
		image: `${BG_BASE}/fondo-scrap-26.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#3d6b8a",
	},
	{
		id: "scrap-27",
		name: "Avión postal",
		color: "#F5EDE0",
		image: `${BG_BASE}/fondo-scrap-27.png`,
		text: "#2c1810",
		textSoft: "rgba(44,24,16,0.55)",
		accent: "#c45c4a",
	},
	{
		id: "kraft",
		name: "Kraft",
		color: "#E8DCC8",
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.55)",
		accent: "#c4956a",
	},
	{
		id: "blanco",
		name: "Blanco",
		color: "#FAF8F5",
		text: "#1a1a2e",
		textSoft: "rgba(26,26,46,0.45)",
		accent: "#6366f1",
	},
	{
		id: "rosa",
		name: "Rosa",
		color: "#FDF0F0",
		text: "#3d2020",
		textSoft: "rgba(61,32,32,0.5)",
		accent: "#e8677d",
	},
	{
		id: "sage",
		name: "Sage",
		color: "#EDF3EC",
		text: "#2d3a2b",
		textSoft: "rgba(45,58,43,0.5)",
		accent: "#6b8f65",
	},
	{
		id: "lavanda",
		name: "Lavanda",
		color: "#F0EDF8",
		text: "#2e2645",
		textSoft: "rgba(46,38,69,0.5)",
		accent: "#8b6fc0",
	},
	{
		id: "melocoton",
		name: "Melocotón",
		color: "#FEF3EA",
		text: "#3d2c1e",
		textSoft: "rgba(61,44,30,0.5)",
		accent: "#e09060",
	},
];

/* ═══════════════════════════════════════════════
   Templates — page layouts
   Each template defines photo slots, text slots
   and decorative elements.
   Coordinates are in canvas units (1080×1920).
   ═══════════════════════════════════════════════ */
/* ═══════════════════════════════════════════════
   COVER TEMPLATES — portada layouts
   ═══════════════════════════════════════════════ */
export const COVER_TEMPLATES = [
	{
		id: "cover-classic",
		name: "Clásica",
		photoSlots: [
			{ id: "photo", x: 540, y: 940, width: 520, height: 520, rotation: -3, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 500, width: 900, placeholder: "Mi viaje", defaultValue: "Mi viaje", fontSize: 110, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
		],
		decorations: [],
	},
	{
		id: "cover-minimal",
		name: "Minimalista",
		photoSlots: [],
		textSlots: [
			{ id: "city", x: 540, y: 820, width: 940, placeholder: "Mi viaje", defaultValue: "Mi viaje", fontSize: 130, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "date", x: 540, y: 1000, width: 700, placeholder: "Septiembre 2026", defaultValue: "Septiembre 2026", fontSize: 42, fontFamily: "Lora", fontStyle: "italic", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 1100, width: 300, height: 3, rotation: 0, color: "accent", opacity: 0.55 },
		],
	},
	{
		id: "cover-collage",
		name: "Collage",
		photoSlots: [
			{ id: "foto-1", x: 300, y: 820, width: 420, height: 420, rotation: -8, frame: "polaroid" },
			{ id: "foto-2", x: 760, y: 880, width: 400, height: 400, rotation: 6, frame: "polaroid" },
			{ id: "foto-3", x: 540, y: 1400, width: 480, height: 480, rotation: -3, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 380, width: 900, placeholder: "Mi viaje", defaultValue: "Mi viaje", fontSize: 100, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "date", x: 540, y: 500, width: 700, placeholder: "Septiembre 2026", defaultValue: "Septiembre 2026", fontSize: 34, fontFamily: "Lora", fontStyle: "italic", align: "center" },
		],
		decorations: [],
	},
];

/* ═══════════════════════════════════════════════
   PAGE TEMPLATES — interior page layouts
   ═══════════════════════════════════════════════ */
export const PAGE_TEMPLATES = [
	{
		id: "blank",
		name: "En blanco",
		defaultBgId: "kraft",
		photoSlots: [],
		textSlots: [],
		decorations: [],
	},
	{
		id: "photo-day",
		name: "Foto del día",
		photoSlots: [
			{ id: "main", x: 540, y: 950, width: 800, height: 800, rotation: -2, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 240, width: 900, placeholder: "DÍA 1", fontSize: 104, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "subtitle", x: 540, y: 355, width: 780, placeholder: "¿Dónde estabas?", fontSize: 40, fontFamily: "Lora", fontStyle: "italic", align: "center" },
			{ id: "caption", x: 540, y: 1530, width: 820, placeholder: "Escribe tu recuerdo aquí...", fontSize: 38, fontFamily: "Lora", fontStyle: "normal", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 440, width: 220, height: 3, color: "accent", opacity: 0.55 },
			{ type: "washi", x: 540, y: 1450, width: 140, height: 2, color: "soft", opacity: 0.4 },
		],
	},
	{
		id: "gallery",
		name: "Galería",
		photoSlots: [
			{ id: "g1", x: 310, y: 580, width: 420, height: 420, rotation: -5, frame: "polaroid" },
			{ id: "g2", x: 770, y: 640, width: 420, height: 420, rotation: 4, frame: "polaroid" },
			{ id: "g3", x: 330, y: 1220, width: 420, height: 420, rotation: 3, frame: "polaroid" },
			{ id: "g4", x: 750, y: 1280, width: 420, height: 420, rotation: -4, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 200, width: 900, placeholder: "Mis fotos", fontSize: 64, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 290, width: 160, height: 3, color: "accent", opacity: 0.5 },
		],
	},
	{
		id: "food",
		name: "Sabores",
		defaultBgId: "scrap-25",
		photoSlots: [
			{ id: "food1", x: 300, y: 630, width: 380, height: 380, rotation: -3, frame: "tape" },
			{ id: "food2", x: 780, y: 670, width: 380, height: 380, rotation: 3, frame: "tape" },
			{ id: "food3", x: 540, y: 1320, width: 440, height: 440, rotation: 2, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 210, width: 900, placeholder: "SABORES", fontSize: 96, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "subtitle", x: 540, y: 320, width: 760, placeholder: "del viaje", fontSize: 36, fontFamily: "Lora", fontStyle: "italic", align: "center" },
			{ id: "cap1", x: 300, y: 900, width: 400, placeholder: "Primer plato...", fontSize: 32, fontFamily: "Lora", fontStyle: "normal", align: "center" },
			{ id: "cap2", x: 780, y: 940, width: 400, placeholder: "Segundo plato...", fontSize: 32, fontFamily: "Lora", fontStyle: "normal", align: "center" },
			{ id: "cap3", x: 540, y: 1670, width: 500, placeholder: "Tercer plato...", fontSize: 32, fontFamily: "Lora", fontStyle: "normal", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 380, width: 200, height: 3, color: "accent", opacity: 0.55 },
		],
	},
	{
		id: "favorite",
		name: "Mi momento favorito",
		defaultBgId: "scrap-24",
		photoSlots: [
			{ id: "foto-1", x: 460, y: 680, width: 540, height: 500, rotation: -4, frame: "polaroid" },
			{ id: "foto-2", x: 620, y: 1220, width: 540, height: 500, rotation: 4, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 220, width: 920, placeholder: "MI MOMENTO FAVORITO", fontSize: 60, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "quote", x: 540, y: 1640, width: 820, placeholder: "\"Escribe una frase especial...\"", fontSize: 40, fontFamily: "Lora", fontStyle: "italic", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 340, width: 200, height: 3, color: "accent", opacity: 0.55 },
		],
	},
	{
		id: "top5",
		name: "Mi top 5",
		photoSlots: [],
		textSlots: [
			{ id: "title", x: 540, y: 230, width: 920, placeholder: "MI TOP 5", fontSize: 92, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "subtitle", x: 540, y: 330, width: 760, placeholder: "Mis sitios favoritos", fontSize: 36, fontFamily: "Lora", fontStyle: "italic", align: "center" },
			{ id: "item1", x: 590, y: 570, width: 680, placeholder: "El mejor lugar...", fontSize: 44, fontFamily: "Lora", fontStyle: "normal", align: "left" },
			{ id: "item2", x: 590, y: 810, width: 680, placeholder: "Segundo favorito...", fontSize: 44, fontFamily: "Lora", fontStyle: "normal", align: "left" },
			{ id: "item3", x: 590, y: 1050, width: 680, placeholder: "Tercer favorito...", fontSize: 44, fontFamily: "Lora", fontStyle: "normal", align: "left" },
			{ id: "item4", x: 590, y: 1290, width: 680, placeholder: "Cuarto favorito...", fontSize: 44, fontFamily: "Lora", fontStyle: "normal", align: "left" },
			{ id: "item5", x: 590, y: 1530, width: 680, placeholder: "Quinto favorito...", fontSize: 44, fontFamily: "Lora", fontStyle: "normal", align: "left" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 420, width: 220, height: 3, color: "accent", opacity: 0.55 },
			{ type: "text", content: "01", x: 170, y: 570, width: 120, fontSize: 54, fontFamily: "Playfair Display", fontStyle: "bold", color: "accent", opacity: 0.75 },
			{ type: "text", content: "02", x: 170, y: 810, width: 120, fontSize: 54, fontFamily: "Playfair Display", fontStyle: "bold", color: "accent", opacity: 0.75 },
			{ type: "text", content: "03", x: 170, y: 1050, width: 120, fontSize: 54, fontFamily: "Playfair Display", fontStyle: "bold", color: "accent", opacity: 0.75 },
			{ type: "text", content: "04", x: 170, y: 1290, width: 120, fontSize: 54, fontFamily: "Playfair Display", fontStyle: "bold", color: "accent", opacity: 0.75 },
			{ type: "text", content: "05", x: 170, y: 1530, width: 120, fontSize: 54, fontFamily: "Playfair Display", fontStyle: "bold", color: "accent", opacity: 0.75 },
			{ type: "washi", x: 570, y: 690, width: 800, height: 2, color: "soft", opacity: 0.35 },
			{ type: "washi", x: 570, y: 930, width: 800, height: 2, color: "soft", opacity: 0.35 },
			{ type: "washi", x: 570, y: 1170, width: 800, height: 2, color: "soft", opacity: 0.35 },
			{ type: "washi", x: 570, y: 1410, width: 800, height: 2, color: "soft", opacity: 0.35 },
			{ type: "washi", x: 570, y: 1650, width: 800, height: 2, color: "soft", opacity: 0.35 },
		],
	},
	{
		id: "diary",
		name: "Diario del día",
		defaultBgId: "scrap-23",
		photoSlots: [
			{ id: "small", x: 810, y: 340, width: 320, height: 320, rotation: 4, frame: "tape" },
		],
		textSlots: [
			{ id: "day", x: 370, y: 220, width: 460, placeholder: "DÍA 1", fontSize: 80, fontFamily: "Playfair Display", fontStyle: "bold", align: "left" },
			{ id: "date", x: 370, y: 320, width: 460, placeholder: "Lunes, 7 septiembre", fontSize: 32, fontFamily: "Lora", fontStyle: "italic", align: "left" },
			{ id: "entry", x: 540, y: 710, width: 880, placeholder: "Hoy ha sido un día increíble. Hemos empezado desayunando en una cafetería preciosa...\n\nEscribe lo que quieras recordar de este día.", fontSize: 36, fontFamily: "Lora", fontStyle: "normal", align: "left" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 1160, width: 920, height: 1020, color: "#FFFFFF", opacity: 0.4, cornerRadius: 14 },
			{ type: "washi", x: 540, y: 1620, width: 820, height: 2, color: "soft", opacity: 0.3 },
		],
	},
	{
		id: "notes",
		name: "Notas del viaje",
		defaultBgId: "scrap-26",
		photoSlots: [
			{ id: "n1", x: 320, y: 620, width: 400, height: 400, rotation: -4, frame: "polaroid" },
			{ id: "n2", x: 760, y: 680, width: 400, height: 400, rotation: 4, frame: "polaroid" },
			{ id: "n3", x: 540, y: 1280, width: 460, height: 420, rotation: -2, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 220, width: 900, placeholder: "NOTAS DEL VIAJE", fontSize: 64, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "place", x: 540, y: 320, width: 760, placeholder: "Ciudad o lugar...", fontSize: 34, fontFamily: "Lora", fontStyle: "italic", align: "center" },
			{ id: "note", x: 540, y: 1640, width: 820, placeholder: "Lo que no quiero olvidar...", fontSize: 34, fontFamily: "Lora", fontStyle: "italic", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 400, width: 180, height: 3, color: "accent", opacity: 0.55 },
		],
	},
	{
		id: "letter",
		name: "Carta",
		defaultBgId: "scrap-27",
		photoSlots: [
			{ id: "p1", x: 460, y: 620, width: 520, height: 480, rotation: -4, frame: "polaroid" },
			{ id: "p2", x: 620, y: 1180, width: 520, height: 480, rotation: 4, frame: "polaroid" },
		],
		textSlots: [
			{ id: "intro", x: 540, y: 140, width: 860, placeholder: "HOLA DESDE", fontSize: 36, fontFamily: "Lora", fontStyle: "italic", align: "center" },
			{ id: "place", x: 540, y: 230, width: 920, placeholder: "tu destino", fontSize: 88, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
			{ id: "note", x: 540, y: 1600, width: 820, placeholder: "Ojalá estuvieras aquí", fontSize: 38, fontFamily: "Lora", fontStyle: "italic", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 340, width: 160, height: 3, color: "accent", opacity: 0.5 },
		],
	},
	{
		id: "day-parts",
		name: "Mañana, tarde, noche",
		defaultBgId: "scrap-22",
		photoSlots: [
			{ id: "morning", x: 560, y: 500, width: 640, height: 380, rotation: -2, frame: "polaroid" },
			{ id: "afternoon", x: 560, y: 1000, width: 640, height: 380, rotation: 2, frame: "polaroid" },
			{ id: "evening", x: 560, y: 1500, width: 640, height: 380, rotation: -2, frame: "polaroid" },
		],
		textSlots: [
			{ id: "title", x: 540, y: 180, width: 900, placeholder: "MI DÍA", fontSize: 64, fontFamily: "Playfair Display", fontStyle: "bold", align: "center" },
		],
		decorations: [
			{ type: "washi", x: 540, y: 260, width: 140, height: 3, color: "accent", opacity: 0.5 },
			{ type: "text", content: "Mañana", x: 150, y: 500, width: 160, fontSize: 28, fontFamily: "Lora", fontStyle: "italic", color: "accent", opacity: 0.85, align: "center" },
			{ type: "text", content: "Tarde", x: 150, y: 1000, width: 160, fontSize: 28, fontFamily: "Lora", fontStyle: "italic", color: "accent", opacity: 0.85, align: "center" },
			{ type: "text", content: "Noche", x: 150, y: 1500, width: 160, fontSize: 28, fontFamily: "Lora", fontStyle: "italic", color: "accent", opacity: 0.85, align: "center" },
		],
	},
];

/* ═══════════════════════════════════════════════
   Decorative stickers (image-based)
   ═══════════════════════════════════════════════ */
export const DECO_STICKERS = [
	{ id: "bon-voyage", name: "Bon Voyage", image: `${DECO_STICKERS_BASE}/decorativo-1.png` },
	{ id: "adventure", name: "Adventure", image: `${DECO_STICKERS_BASE}/decorativo-2.png` },
	{ id: "camera", name: "Cámara", image: `${DECO_STICKERS_BASE}/decorativo-3.png` },
	{ id: "boarding-pass", name: "Boarding pass", image: `${DECO_STICKERS_BASE}/decorativo-4.png` },
	{ id: "map-moments", name: "Mapa", image: `${DECO_STICKERS_BASE}/decorativo-5.png` },
	{ id: "globe", name: "Globo", image: `${DECO_STICKERS_BASE}/decorativo-6.png` },
	{ id: "passport", name: "Pasaporte", image: `${DECO_STICKERS_BASE}/decorativo-7.png` },
	{ id: "heart", name: "Corazón", image: `${DECO_STICKERS_BASE}/decorativo-8.png` },
	{ id: "signpost", name: "Señal", image: `${DECO_STICKERS_BASE}/decorativo-9.png` },
	{ id: "coffee", name: "Café", image: `${DECO_STICKERS_BASE}/decorativo-10.png` },
	{ id: "postcard", name: "Postal", image: `${DECO_STICKERS_BASE}/decorativo-11.png` },
	{ id: "compass", name: "Brújula", image: `${DECO_STICKERS_BASE}/decorativo-12.png` },
	{ id: "sun", name: "Sol", image: `${DECO_STICKERS_BASE}/decorativo-13.png` },
	{ id: "plane-heart", name: "Avión", image: `${DECO_STICKERS_BASE}/decorativo-14.png` },
	{ id: "banners", name: "Etiquetas", image: `${DECO_STICKERS_BASE}/decorativo-15.png` },
	{ id: "hibiscus", name: "Flor", image: `${DECO_STICKERS_BASE}/decorativo-16.png` },
	{ id: "shell", name: "Concha", image: `${DECO_STICKERS_BASE}/decorativo-17.png` },
	{ id: "lemon-stamp", name: "Sello limón", image: `${DECO_STICKERS_BASE}/decorativo-18.png` },
	{ id: "map-pin", name: "Pin", image: `${DECO_STICKERS_BASE}/decorativo-19.png` },
	{ id: "explore-mountains", name: "Explore", image: `${DECO_STICKERS_BASE}/decorativo-20.png` },
	{ id: "green-heart", name: "Corazón verde", image: `${DECO_STICKERS_BASE}/decorativo-21.png` },
	{ id: "world-heart", name: "Mundo", image: `${DECO_STICKERS_BASE}/decorativo-22.png` },
	{ id: "palms", name: "Palmeras", image: `${DECO_STICKERS_BASE}/decorativo-23.png` },
];

/* ═══════════════════════════════════════════════
   Washi tape colors (for user to add)
   ═══════════════════════════════════════════════ */
export const WASHI_TAPES = [
	{ id: "w-hearts", name: "Corazones", image: `${WASHI_BASE}/washi-tape-1.png`, width: 480 },
	{ id: "w-dots", name: "Lunares", image: `${WASHI_BASE}/washi-tape-2.png`, width: 480 },
	{ id: "w-travel", name: "Viaje", image: `${WASHI_BASE}/washi-tape-3.png`, width: 480 },
	{ id: "w-travel-more", name: "Travel more", image: `${WASHI_BASE}/washi-tape-4.png`, width: 480 },
	{ id: "w-landmarks", name: "Ciudades", image: `${WASHI_BASE}/washi-tape-5.png`, width: 480 },
	{ id: "w-passport", name: "Equipaje", image: `${WASHI_BASE}/washi-tape-6.png`, width: 480 },
	{ id: "w-destination", name: "Destino", image: `${WASHI_BASE}/washi-tape-7.png`, width: 480 },
	{ id: "w-flight", name: "Vuelo", image: `${WASHI_BASE}/washi-tape-8.png`, width: 420 },
	{ id: "w-globes", name: "Mundos", image: `${WASHI_BASE}/washi-tape-9.png`, width: 420 },
	{ id: "w-suitcases", name: "Maletas", image: `${WASHI_BASE}/washi-tape-10.png`, width: 420 },
	{ id: "w-explore", name: "Explore", image: `${WASHI_BASE}/washi-tape-11.png`, width: 420 },
	{ id: "w-planes", name: "Aviones", image: `${WASHI_BASE}/washi-tape-12.png`, width: 420 },
	{ id: "w-pins", name: "Pines", image: `${WASHI_BASE}/washi-tape-13.png`, width: 420 },
	{ id: "w-cameras", name: "Cámaras", image: `${WASHI_BASE}/washi-tape-14.png`, width: 420 },
	{ id: "w-pink", name: "Rosa", image: `${WASHI_BASE}/washi-tape-15.png`, width: 420 },
	{ id: "w-lavender", name: "Lavanda", image: `${WASHI_BASE}/washi-tape-16.png`, width: 420 },
	{ id: "w-peach", name: "Melocotón", image: `${WASHI_BASE}/washi-tape-17.png`, width: 420 },
	{ id: "w-yellow", name: "Amarillo", image: `${WASHI_BASE}/washi-tape-18.png`, width: 420 },
	{ id: "w-mint", name: "Menta", image: `${WASHI_BASE}/washi-tape-19.png`, width: 420 },
	{ id: "w-cream", name: "Crema", image: `${WASHI_BASE}/washi-tape-20.png`, width: 420 },
	{ id: "w-sky", name: "Azul", image: `${WASHI_BASE}/washi-tape-21.png`, width: 420 },
];

/* ═══════════════════════════════════════════════
   City sticker packs (álbum)
   ═══════════════════════════════════════════════ */
export const CITY_STICKERS = {
	"nueva-york": [
		{ id: "ny-script", name: "New York", image: `${NY_STICKERS_BASE}/ny-1.png` },
		{ id: "ny-apple", name: "The Big Apple", image: `${NY_STICKERS_BASE}/ny-2.png` },
		{ id: "ny-statue", name: "Estatua de la Libertad", image: `${NY_STICKERS_BASE}/ny-3.png` },
		{ id: "ny-taxi", name: "Taxi", image: `${NY_STICKERS_BASE}/ny-4.png` },
		{ id: "ny-broadway", name: "Broadway", image: `${NY_STICKERS_BASE}/ny-5.png` },
		{ id: "ny-stamp", name: "Sello", image: `${NY_STICKERS_BASE}/ny-6.png` },
		{ id: "ny-skyline", name: "Skyline", image: `${NY_STICKERS_BASE}/ny-7.png` },
		{ id: "ny-taxi-sign", name: "Taxi sign", image: `${NY_STICKERS_BASE}/ny-8.png` },
		{ id: "ny-central-park", name: "Central Park", image: `${NY_STICKERS_BASE}/ny-9.png` },
		{ id: "ny-moments", name: "Collect moments", image: `${NY_STICKERS_BASE}/ny-10.png` },
		{ id: "ny-pizza", name: "Pizza", image: `${NY_STICKERS_BASE}/ny-11.png` },
		{ id: "ny-tag", name: "Etiqueta NYC", image: `${NY_STICKERS_BASE}/ny-12.png` },
		{ id: "ny-pretzel", name: "Pretzel", image: `${NY_STICKERS_BASE}/ny-13.png` },
		{ id: "ny-subway", name: "Subway", image: `${NY_STICKERS_BASE}/ny-14.png` },
		{ id: "ny-neighborhoods", name: "Barrios", image: `${NY_STICKERS_BASE}/ny-15.png` },
		{ id: "ny-brooklyn", name: "Brooklyn Bridge", image: `${NY_STICKERS_BASE}/ny-16.png` },
		{ id: "ny-iloveny", name: "I Love NY", image: `${NY_STICKERS_BASE}/ny-17.png` },
		{ id: "ny-central-sign", name: "Señal Central Park", image: `${NY_STICKERS_BASE}/ny-18.png` },
		{ id: "ny-ticket", name: "Ticket NYC", image: `${NY_STICKERS_BASE}/ny-19.png` },
	],
	japon: [
		{ id: "jp-fuji", name: "Monte Fuji", image: `${JP_STICKERS_BASE}/japan-1.png` },
		{ id: "jp-torii", name: "Torii", image: `${JP_STICKERS_BASE}/japan-2.png` },
		{ id: "jp-sakura", name: "Sakura", image: `${JP_STICKERS_BASE}/japan-3.png` },
		{ id: "jp-lantern", name: "Farol Tokio", image: `${JP_STICKERS_BASE}/japan-4.png` },
		{ id: "jp-pagoda", name: "Pagoda", image: `${JP_STICKERS_BASE}/japan-5.png` },
		{ id: "jp-sakura-branch", name: "Rama sakura", image: `${JP_STICKERS_BASE}/japan-6.png` },
		{ id: "jp-neko", name: "Maneki-neko", image: `${JP_STICKERS_BASE}/japan-7.png` },
		{ id: "jp-castle", name: "Castillo", image: `${JP_STICKERS_BASE}/japan-8.png` },
		{ id: "jp-map", name: "Mapa Japón", image: `${JP_STICKERS_BASE}/japan-9.png` },
		{ id: "jp-daruma", name: "Daruma", image: `${JP_STICKERS_BASE}/japan-10.png` },
		{ id: "jp-fuji-stamp", name: "Sello Fuji", image: `${JP_STICKERS_BASE}/japan-11.png` },
		{ id: "jp-tag", name: "Etiqueta Japón", image: `${JP_STICKERS_BASE}/japan-12.png` },
		{ id: "jp-ramen", name: "Ramen", image: `${JP_STICKERS_BASE}/japan-13.png` },
		{ id: "jp-sushi", name: "Sushi", image: `${JP_STICKERS_BASE}/japan-14.png` },
		{ id: "jp-shinkansen", name: "Shinkansen", image: `${JP_STICKERS_BASE}/japan-15.png` },
		{ id: "jp-crane", name: "Grulla", image: `${JP_STICKERS_BASE}/japan-16.png` },
		{ id: "jp-kyoto", name: "Kioto", image: `${JP_STICKERS_BASE}/japan-17.png` },
		{ id: "jp-parasol", name: "Parasol", image: `${JP_STICKERS_BASE}/japan-18.png` },
	],
	china: [
		{ id: "cn-tiantan", name: "Templo del Cielo", image: `${CN_STICKERS_BASE}/china-1.png` },
		{ id: "cn-script", name: "China", image: `${CN_STICKERS_BASE}/china-2.png` },
		{ id: "cn-boarding", name: "Boarding pass", image: `${CN_STICKERS_BASE}/china-3.png` },
		{ id: "cn-stamp", name: "Sello panda", image: `${CN_STICKERS_BASE}/china-4.png` },
		{ id: "cn-wall", name: "Gran Muralla", image: `${CN_STICKERS_BASE}/china-5.png` },
		{ id: "cn-dumplings", name: "Dumplings", image: `${CN_STICKERS_BASE}/china-6.png` },
		{ id: "cn-lantern", name: "Farol", image: `${CN_STICKERS_BASE}/china-7.png` },
		{ id: "cn-gatehouse", name: "Torre", image: `${CN_STICKERS_BASE}/china-8.png` },
		{ id: "cn-xian", name: "Xi'an", image: `${CN_STICKERS_BASE}/china-9.png` },
		{ id: "cn-warrior", name: "Guerrero", image: `${CN_STICKERS_BASE}/china-10.png` },
		{ id: "cn-junk", name: "Barco", image: `${CN_STICKERS_BASE}/china-11.png` },
		{ id: "cn-panda", name: "Panda", image: `${CN_STICKERS_BASE}/china-12.png` },
		{ id: "cn-noodles", name: "Fideos", image: `${CN_STICKERS_BASE}/china-13.png` },
		{ id: "cn-shanghai", name: "Shanghái", image: `${CN_STICKERS_BASE}/china-14.png` },
		{ id: "cn-beijing-tag", name: "Beijing", image: `${CN_STICKERS_BASE}/china-15.png` },
		{ id: "cn-shanghai-tag", name: "Etiqueta Shanghái", image: `${CN_STICKERS_BASE}/china-16.png` },
		{ id: "cn-great-wall-stamp", name: "Sello Gran Muralla", image: `${CN_STICKERS_BASE}/china-17.png` },
		{ id: "cn-lanterns-tape", name: "Faroles", image: `${CN_STICKERS_BASE}/china-18.png` },
		{ id: "cn-panda-tape", name: "Pandas", image: `${CN_STICKERS_BASE}/china-19.png` },
		{ id: "cn-clouds-tape", name: "Nubes", image: `${CN_STICKERS_BASE}/china-20.png` },
		{ id: "cn-tea", name: "Té", image: `${CN_STICKERS_BASE}/china-21.png` },
	],
	londres: [
		{ id: "lon-bigben", name: "Big Ben", image: `${LON_STICKERS_BASE}/londres-1.png` },
		{ id: "lon-script", name: "London", image: `${LON_STICKERS_BASE}/londres-2.png` },
		{ id: "lon-bus", name: "Autobús", image: `${LON_STICKERS_BASE}/londres-3.png` },
		{ id: "lon-phone", name: "Cabina", image: `${LON_STICKERS_BASE}/londres-4.png` },
		{ id: "lon-tea", name: "Tea time", image: `${LON_STICKERS_BASE}/londres-5.png` },
		{ id: "lon-taxi", name: "Taxi", image: `${LON_STICKERS_BASE}/londres-6.png` },
		{ id: "lon-tower-bridge", name: "Tower Bridge", image: `${LON_STICKERS_BASE}/londres-7.png` },
		{ id: "lon-flag", name: "Union Jack", image: `${LON_STICKERS_BASE}/londres-8.png` },
		{ id: "lon-crown", name: "Corona", image: `${LON_STICKERS_BASE}/londres-9.png` },
		{ id: "lon-eye", name: "London Eye", image: `${LON_STICKERS_BASE}/londres-10.png` },
		{ id: "lon-umbrella", name: "Paraguas", image: `${LON_STICKERS_BASE}/londres-11.png` },
		{ id: "lon-quote", name: "Good Things", image: `${LON_STICKERS_BASE}/londres-12.png` },
		{ id: "lon-houses", name: "Casas", image: `${LON_STICKERS_BASE}/londres-13.png` },
		{ id: "lon-stamp", name: "Sello", image: `${LON_STICKERS_BASE}/londres-14.png` },
		{ id: "lon-scones", name: "Scones", image: `${LON_STICKERS_BASE}/londres-15.png` },
		{ id: "lon-tag", name: "Etiqueta", image: `${LON_STICKERS_BASE}/londres-16.png` },
		{ id: "lon-roses", name: "Rosas", image: `${LON_STICKERS_BASE}/londres-17.png` },
		{ id: "lon-ticket", name: "Ticket", image: `${LON_STICKERS_BASE}/londres-18.png` },
	],
	paris: [
		{ id: "pa-eiffel", name: "Torre Eiffel", image: `${PARIS_STICKERS_BASE}/paris-1.png` },
		{ id: "pa-script", name: "Paris", image: `${PARIS_STICKERS_BASE}/paris-2.png` },
		{ id: "pa-croissant", name: "Croissant", image: `${PARIS_STICKERS_BASE}/paris-3.png` },
		{ id: "pa-metro", name: "Métro", image: `${PARIS_STICKERS_BASE}/paris-4.png` },
		{ id: "pa-macarons", name: "Macarons", image: `${PARIS_STICKERS_BASE}/paris-5.png` },
		{ id: "pa-lavender", name: "Lavanda", image: `${PARIS_STICKERS_BASE}/paris-6.png` },
		{ id: "pa-arc", name: "Arco del Triunfo", image: `${PARIS_STICKERS_BASE}/paris-7.png` },
		{ id: "pa-je-taime", name: "Je t'aime", image: `${PARIS_STICKERS_BASE}/paris-8.png` },
		{ id: "pa-seine", name: "Sena", image: `${PARIS_STICKERS_BASE}/paris-9.png` },
		{ id: "pa-louvre", name: "Louvre", image: `${PARIS_STICKERS_BASE}/paris-10.png` },
		{ id: "pa-baguette", name: "Baguette", image: `${PARIS_STICKERS_BASE}/paris-11.png` },
		{ id: "pa-eiffel-park", name: "Eiffel parque", image: `${PARIS_STICKERS_BASE}/paris-12.png` },
		{ id: "pa-cafe", name: "Café de Paris", image: `${PARIS_STICKERS_BASE}/paris-13.png` },
		{ id: "pa-stamp", name: "Sello", image: `${PARIS_STICKERS_BASE}/paris-14.png` },
		{ id: "pa-champs", name: "Champs-Élysées", image: `${PARIS_STICKERS_BASE}/paris-15.png` },
		{ id: "pa-oh-la-la", name: "Oh là là", image: `${PARIS_STICKERS_BASE}/paris-16.png` },
		{ id: "pa-bike", name: "Bici", image: `${PARIS_STICKERS_BASE}/paris-17.png` },
		{ id: "pa-lamp", name: "Farola", image: `${PARIS_STICKERS_BASE}/paris-18.png` },
	],
};

/* ═══════════════════════════════════════════════
   Cover pages — pre-made full-page designs
   ═══════════════════════════════════════════════ */
export const COVERS = [
	{
		id: "ny-statue",
		name: "Estatua de la Libertad",
		city: "Nueva York",
		category: "nueva-york",
		image: `${COVERS_BASE}/portada-ny-1.png`,
	},
];

/* Categories for cover picker */
export const COVER_CATEGORIES = [
	{ id: "nueva-york", name: "Nueva York", emoji: "🗽" },
	{ id: "japon", name: "Japón", emoji: "⛩️" },
	{ id: "china", name: "China", emoji: "🇨🇳" },
	{ id: "tokio", name: "Tokio", emoji: "⛩️" },
	{ id: "londres", name: "Londres", emoji: "🇬🇧" },
	{ id: "paris", name: "París", emoji: "🗼" },
	{ id: "seul", name: "Seúl", emoji: "🇰🇷" },
];

/* Fonts for scrapbook text */
export const FONT_OPTIONS = [
	{ id: "Playfair Display", name: "Playfair" },
	{ id: "Cormorant Garamond", name: "Cormorant" },
	{ id: "DM Serif Display", name: "DM Serif" },
	{ id: "Cinzel", name: "Cinzel" },
	{ id: "Lora", name: "Lora" },
	{ id: "Allura", name: "Allura" },
	{ id: "Italianno", name: "Italianno" },
	{ id: "Sacramento", name: "Sacramento" },
	{ id: "Parisienne", name: "Parisienne" },
	{ id: "Pinyon Script", name: "Pinyon" },
	{ id: "Great Vibes", name: "Great Vibes" },
	{ id: "Homemade Apple", name: "Homemade Apple" },
];

export const TEXT_COLOR_PRESETS = [
	"#3d2c1e",
	"#1a1a2e",
	"#ffffff",
	"#c41e3a",
	"#1e3a5f",
	"#c45c4a",
	"#5a7a9a",
	"#2d6a4f",
];

/* Default background for interior page templates */
export const DEFAULT_PAGE_BG_ID = "scrap-22";

/* All templates combined (for internal lookups) */
export const ALL_TEMPLATES = [...COVER_TEMPLATES, ...PAGE_TEMPLATES];

const scrapbookConfig = {
	CANVAS_W,
	CANVAS_H,
	BACKGROUNDS,
	COVER_TEMPLATES,
	PAGE_TEMPLATES,
	ALL_TEMPLATES,
	DEFAULT_PAGE_BG_ID,
	DECO_STICKERS,
	WASHI_TAPES,
	CITY_STICKERS,
	COVERS,
	COVER_CATEGORIES,
	FONT_OPTIONS,
	TEXT_COLOR_PRESETS,
};

export default scrapbookConfig;
